<template>
  <view class="card">
    <view class="card-item" v-for="(item, index) in list" :key="index">
      <view class="a-w-84 a-h-100 a-shrink-0 skeleton-back"></view>
      <view class="a-w-100% a-h-36 a-m-20 skeleton-back"></view>
      <view class="a-w-80 a-h-80 a-shrink-0 skeleton-back"></view>
    </view>
  </view>
</template>

<script>
export default {
  data() {
    return {
      list: new Array(5).fill(null),
    };
  },
  onLoad() {},
  methods: {},
};
</script>

<style lang="less" scoped scoped>
@import url('@/pages/product2.0/css/skeletonLoading.less');

.card {
  padding: 20rpx 20rpx 0 20rpx;
}

.card-item {
  width: 100%;
  height: 140rpx;
  padding: 20rpx 30rpx 20rpx 20rpx;
  background-color: #ffffff;
  border-radius: 12rpx;
  box-shadow: 0px 30rpx 30rpx 0px rgba(0, 0, 0, 0.02);
  margin-bottom: 20rpx;
  display: flex;
  align-items: center;
  justify-content: space-between;

  &:last-child {
    margin: 0;
  }
}
</style>
